/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Hope
 */
export interface Hope {
    /**
     * 
     * @type {Array<string>}
     * @memberof Hope
     */
    conservationReport: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Hope
     */
    aminoAcidPropertiesReport: Array<string>;
}

/**
 * Check if a given object implements the Hope interface.
 */
export function instanceOfHope(value: object): value is Hope {
    if (!('conservationReport' in value) || value['conservationReport'] === undefined) return false;
    if (!('aminoAcidPropertiesReport' in value) || value['aminoAcidPropertiesReport'] === undefined) return false;
    return true;
}

export function HopeFromJSON(json: any): Hope {
    return HopeFromJSONTyped(json, false);
}

export function HopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Hope {
    if (json == null) {
        return json;
    }
    return {
        
        'conservationReport': json['conservationReport'],
        'aminoAcidPropertiesReport': json['aminoAcidPropertiesReport'],
    };
}

export function HopeToJSON(json: any): Hope {
    return HopeToJSONTyped(json, false);
}

export function HopeToJSONTyped(value?: Hope | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conservationReport': value['conservationReport'],
        'aminoAcidPropertiesReport': value['aminoAcidPropertiesReport'],
    };
}

